import React, { Component } from 'react'
import {Link, Redirect} from 'react-router-dom'
import CardFormulario from '../../../Utils/Cards/cardFormulario';
import LoadMask from '../../../Utils/LoadMask/LoadMask';
// formulario
import DespachoForm from './despachoForm';
import {api} from 'api';


export default class DespachoContainer extends Component {

    state = {
        bodegaOrigen: null,
        bodegaDestino: null,
    }

    componentDidMount(){
        let id = this.props.match.params.id
        this.props.getDetalleOrden(id);
        this.props.leerOrdenCompra(id);
        if (id != undefined && id != null){

        }else{
            return (<Redirect to="/ordenesventa" />)
        }
    }

    handleSubmit = (values) => {
        const { DespacharProducto } = this.props;
        const { bodegaOrigen, bodegaDestino } = this.state;
        let id = this.props.match.params.id;
        let valores = { ...values };
        valores.tipo_movimiento = 10;


        // Actualizar la información de "Empresas" por información de "Bodegas"
        valores.bodega_origen = bodegaOrigen ? bodegaOrigen.id : valores.bodega_origen.id;
        valores.bodega_destino = bodegaDestino ? bodegaDestino.id : valores.bodega_destino.id;

        let productos = [];
        valores.Despachos.forEach(item => {
            productos.push(item.producto.id);
        });
        valores.productos = productos;
        DespacharProducto(valores, id)
    }

    async componentDidUpdate(prevProps) {
        const { item } = this.props;

        const tieneEmpresas = item.empresa_origen && item.empresa_destino;
        const datosActualizados = this.state.bodegaOrigen || this.state.bodegaDestino;

        if (tieneEmpresas && !datosActualizados) {
            const idOrigen = item.empresa_origen.id;
            const idDestino = item.empresa_destino.id;

            const [resOrigen, resDestino] = await Promise.all([
                api.get("bodega", { empresa: idOrigen }),
                api.get("bodega", { empresa: idDestino }),
            ]);

            this.setState({
                bodegaOrigen: resOrigen.results[0],
                bodegaDestino: resDestino.results[0],
            });
        }
    }

    render() {
        const { loader, item } = this.props;
        return (
            <CardFormulario titulo={"Despacho"}>
                <LoadMask loading={loader} light type={"TailSpin"}>
                    <DespachoForm
                        item={item}
                        orden={this.props.match.params.id}
                        onSubmit={this.handleSubmit}
                        initialValues={{
                            bodega_origen: item.empresa_origen || null,
                            bodega_destino: item.empresa_destino || null,
                        }}
                    />
                </LoadMask>
            </CardFormulario>
        )
    }
}
